import { ActivityFilterKey } from '@gripp/shared-logic';
import { ActivitySearch } from '@gripp/shared-ui';

interface ActivitySearchModalProps {
  isVisible: boolean;
  onDismiss: () => void;
  filterKey?: ActivityFilterKey;
}

export const ActivitySearchModal = ({
  isVisible,
  onDismiss,
  filterKey = ActivityFilterKey.Activity,
}: ActivitySearchModalProps) => (
  <ActivitySearch
    mode="modal"
    isVisible={isVisible}
    onDismiss={onDismiss}
    filterKey={filterKey}
  />
);
